module.exports = __webpack_public_path__ + "static/media/corelogic-emap-logo.f61f1f41.svg";